import { render, staticRenderFns } from "./CompanyTable.vue?vue&type=template&id=223fb9fe&scoped=true&"
import script from "./CompanyTable.vue?vue&type=script&lang=js&"
export * from "./CompanyTable.vue?vue&type=script&lang=js&"
import style0 from "./CompanyTable.vue?vue&type=style&index=0&id=223fb9fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223fb9fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDataTable,VIcon})
